module.exports = __webpack_public_path__ + "static/EN_Google_Podcasts_Badge-6ce55e5df4c3c1067bf61ebb7ce35eed.svg";